import * as React from 'react'
import * as Reakit from 'reakit/Dialog'

import { DropdownContext } from '../dropdown'
import { DialogStateReturn } from './hooks'

interface DialogButtonProps extends Reakit.DialogDisclosureHTMLProps {
  state: DialogStateReturn
}
/**
 * The trigger button component which handles ref & focus return, etc.
 */
export const DialogTrigger = React.forwardRef(
  ({ state, ...props }: DialogButtonProps, ref: React.ForwardedRef<HTMLButtonElement>) => {
    const dropdownContext = React.useContext(DropdownContext)

    return (
      <Reakit.DialogDisclosure
        ref={ref}
        {...props}
        {...state}
        onClick={(ev: React.MouseEvent<HTMLButtonElement>) => {
          // Close dropdown if we’re inside one
          dropdownContext?.root.hide()
          props.onClick?.(ev)
        }}
      >
        {props.children}
      </Reakit.DialogDisclosure>
    )
  }
)
